import React, { useContext, useState } from 'react';
// import Modal from "../modal";
import styles from './Auth.module.css';
import Modal from '@/components/structure/Modal';
// import AppImage from "@/components/base/AppImage";
// import { RootContext } from "@/context/RootContext";

interface ViolationImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  violationImageInfo?: any;
}

const ViolationImageModal: React.FC<ViolationImageModalProps> = ({
  isOpen,
  onClose,
  violationImageInfo,
}) => {
  const handleClose = () => {
    onClose();
  };
  const [error, setError] = useState<string>('');
  // const { violationImageInfo } = useContext(RootContext)

  console.log('violationImageInfo====', violationImageInfo);

  return (
    <>
      <Modal
        title="تصویر خلافی"
        // isOpen={isOpen}
        handleShowModal={handleClose}
        // mobileMode="full"
        // error={error}
        extraContentStyle={styles.extraModalContentStyle}
      >
        <div className={`${styles.container}`}>
          {violationImageInfo?.plate_image && (
            <>
              <p className={`${styles.title}`}>تصویر پلاک</p>
              <img
                src={'data:image/png;base64,' + violationImageInfo?.plate_image}
                width={100}
                height={100}
              />
            </>
          )}
          {violationImageInfo?.vehicle_image && (
            <>
              <p className={`${styles.title}`}>تصویر خودرو</p>
              <img
                src={'data:image/png;base64,' + violationImageInfo?.vehicle_image}
                width={100}
                height={100}
              />
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ViolationImageModal;
